import api from './utilBackoffice';

const controller = 'IOF';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => {
    return api.Axios.GetParams(url, dto);
  },
  ListarNaoContabilizados: dto => {
    return api.Axios.GetParams(url + '/IOFNaoContabilizado', dto);
  },
  RequestDownloadIOF: dto => {
    return api.Axios.Post(url, dto);
  },
  RequestDownloadIOFNaoContabilizado: dto => {
    return api.Axios.Post(url + '/RequestDownloadNaoContabilizado', dto);
  }
});
